<template lang="pug">
  .v-switch-wrapper(
    :class="{ 'v-switch-wrapper--with-label': !!label,'disabled': disabled }")
    label.v-switch__label(v-if="label") {{ label }}
    input(
      type="checkbox"
      :checked="value"
      @input="onChange"
    ).v-switch

</template>

<script>
export default {
  name: 'VSwitch',

  props: {
    label: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onChange (event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .v-switch-wrapper {
    display: flex;
    align-items: center;

    &--with-label {
      width: 100%;
      justify-content: space-between;
    }
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .v-switch {
    position: relative;
    flex-shrink: 0;
    width: 4rem;
    height: 2.4rem;
    cursor: pointer;
    -moz-appearance: none;
    -webkit-appearance: none;
    background-color: $color-gray-light-1;
    border-radius: 2rem;
    outline: none;
    transition: .4s ease;

    &:checked {
      background-color: $color-green-light-1;

      &::before {
        left: 1.7rem;
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: .2rem;
      width: 2.1rem;
      height: 2.1rem;
      box-shadow:
        0 0.5px 2.5px rgba(0, 0, 0, 0.2),
        0px 0px 2px rgba(0, 0, 0, 0.1),
        0px 0px 10px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      border-radius: 50%;
      transition: .4s ease;
    }

    &__label {
      font-size: 1.5rem;
      margin-right: 2rem;
    }
  }
</style>
